/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Provide_A_Highconversion_DescInputs */

const en_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide a high-conversion description of your collection...`)
};

const es_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporciona una descripción de alta conversión de tu colección...`)
};

const fr_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournissez une description à fort taux de conversion de votre collection...`)
};

const de_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfasse eine konversionsstarke Beschreibung deiner Kollektion...`)
};

const ja_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクションについて、コンバージョン率の高い説明文を提供してください...`)
};

const zh_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为您的合集提供一段高转化率的描述...`)
};

const ar_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قدم وصفاً عالي التحويل لمجموعتك...`)
};

const id_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikan deskripsi dengan konversi tinggi untuk koleksi Anda...`)
};

const it_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornisci una descrizione ad alta conversione della tua collezione...`)
};

const ru_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предоставьте описание с высокой конверсией для вашей коллекции...`)
};

const pt_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forneça uma descrição de alta conversão para a sua coleção...`)
};

const ko_provide_a_highconversion_desc = /** @type {(inputs: Provide_A_Highconversion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉션에 대해 구매 전환율을 높일 수 있는 설명을 입력해 주세요...`)
};

/**
* | output |
* | --- |
* | "Provide a high-conversion description of your collection..." |
*
* @param {Provide_A_Highconversion_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const provide_a_highconversion_desc = /** @type {((inputs?: Provide_A_Highconversion_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Provide_A_Highconversion_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_provide_a_highconversion_desc(inputs)
	if (locale === "es") return es_provide_a_highconversion_desc(inputs)
	if (locale === "fr") return fr_provide_a_highconversion_desc(inputs)
	if (locale === "de") return de_provide_a_highconversion_desc(inputs)
	if (locale === "ja") return ja_provide_a_highconversion_desc(inputs)
	if (locale === "zh") return zh_provide_a_highconversion_desc(inputs)
	if (locale === "ar") return ar_provide_a_highconversion_desc(inputs)
	if (locale === "id") return id_provide_a_highconversion_desc(inputs)
	if (locale === "it") return it_provide_a_highconversion_desc(inputs)
	if (locale === "ru") return ru_provide_a_highconversion_desc(inputs)
	if (locale === "pt") return pt_provide_a_highconversion_desc(inputs)
	return ko_provide_a_highconversion_desc(inputs)
});